import { render, staticRenderFns } from "./PowerLimitBreachesChart.vue?vue&type=template&id=4b769137&scoped=true&"
import script from "./PowerLimitBreachesChart.vue?vue&type=script&lang=ts&"
export * from "./PowerLimitBreachesChart.vue?vue&type=script&lang=ts&"
import style0 from "./PowerLimitBreachesChart.vue?vue&type=style&index=0&id=4b769137&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b769137",
  null
  
)

export default component.exports